import {useMediaQuery} from 'hooks/useMediaQuery';
import Cookies from 'js-cookie';
import {breakpoints} from 'lib/breakpoints';
import {CartSidebar} from 'modules/Cart/components/CartSidebar/CartSidebar';
import {OrdeSuccessInfo} from 'modules/Cart/components/OrdeSuccessInfo/OrdeSuccessInfo';
import {OrderedProducts} from 'modules/Cart/containers/OrderedProducts/OrderedProducts';
import {useCartSidebar} from 'modules/Cart/hooks/useCartSidebar';
import {useOrderSuccess} from 'modules/Cart/hooks/useOrderSuccess';
import {OrderSuccessSkeleton} from 'modules/Cart/routes/OrderSuccess/OrderSuccessSkeleton';
import {FC, useEffect} from 'react';

import styles from './OrderSuccess.module.css';

type Props = {};
export const OrderSuccess: FC<Props> = () => {
    const {
        orderSuccesInfoData,
        isLoading,
        orderId: orderIdQueryParam,
    } = useOrderSuccess();
    const {regionalDiscounts, total, handleCallback, step} = useCartSidebar();

    // трекаем в аналитику успешный заказ
    useEffect(() => {
        const Ecommerce = window.EcommerceKlen;
        const orderId = orderSuccesInfoData?.order_id;
        if (!Ecommerce || !orderId) {
            return;
        }

        const trackOrdersCookie = Cookies.get('trackEcommerceOrders');
        const trackOrders = JSON.parse(trackOrdersCookie || '[]') || [];
        const orderHasTracked = trackOrders.includes(orderId);

        // если заказ уже трекали, то повторно этого делать не нужно
        if (!orderHasTracked) {
            new Ecommerce('orderSuccess', [orderId]);
        }
    }, [orderSuccesInfoData]);

    const isDesktop = useMediaQuery(breakpoints.up('mmd'));

    if (isLoading) {
        return <OrderSuccessSkeleton />;
    }

    if (!orderSuccesInfoData) {
        return null;
    }

    const sidebar = (
        <CartSidebar
            productsTypeAmount={
                orderSuccesInfoData.total?.products_type_amount || 0
            }
            totalProductsAmount={
                orderSuccesInfoData.total?.products_amount || 0
            }
            totalPriceOfProducts={
                orderSuccesInfoData.total?.price_without_sale || 0
            }
            totalPrice={orderSuccesInfoData.total?.price || 0}
            totalDiscount={orderSuccesInfoData.total?.sale || 0}
            minimalPrice={0}
            regionalDiscounts={regionalDiscounts}
            cartHasRegionalDiscount={total.cartHasRegionalDiscount}
            isSubmittedMode
            step={step}
            handleCallback={handleCallback}
            orderId={orderIdQueryParam}
        />
    );

    return (
        <div className={styles.block}>
            <div className={styles.main}>
                <div className={styles.content}>
                    <div className={styles.info}>
                        <OrdeSuccessInfo
                            orderNumber={orderSuccesInfoData.order_id}
                            email={orderSuccesInfoData?.email}
                            phone={orderSuccesInfoData.phone}
                            address={orderSuccesInfoData.region_title}
                            paymentMethod={orderSuccesInfoData.payment_method}
                        />
                    </div>

                    {!isDesktop && (
                        <div className={styles.sidebar}>{sidebar}</div>
                    )}

                    <div className={styles.orderedProducts}>
                        <OrderedProducts />
                    </div>
                </div>

                {isDesktop && <div className={styles.sidebar}>{sidebar}</div>}
            </div>
        </div>
    );
};
